import { CommonModule } from '@angular/common';
import { Component, input, InputSignal } from '@angular/core';

export type AbstractButton = {
    title: string;
    class: string;
    clicked: () => void;
};

@Component({
    selector: 'web-bottom-buttons',
    templateUrl: './bottom-buttons.component.html',
    styleUrls: ['./bottom-buttons.component.scss'],
    imports: [CommonModule],
})
export class BottomButtonsComponent {
    buttons: InputSignal<AbstractButton[]> = input<AbstractButton[]>([]);
}
